import { api } from '../../lib/api.ts';
import type {
  AppRolesResponse,
  UpdateAppRolesBody,
  ProvisionAppBody,
  AppRoleUpdateStatus,
  AppProvisionStatus,
} from '../appRoles/api.ts';

export interface OrgUserRow {
  id: string;
  email: string;
  name: string;
  nameDv: string | null;
  role: 'SYS_ADMIN' | 'USER';
  isOrgAdmin: boolean;
  isActive: boolean;
  designationDv: string | null;
  designationEn: string | null;
  section: string | null;
}

export interface OrgUserPatch {
  isOrgAdmin?: boolean;
  isActive?: boolean;
  nameDv?: string | null;
  designationDv?: string | null;
  designationEn?: string | null;
  section?: string | null;
}

export const usersApi = {
  list: () => api.get<{ users: OrgUserRow[] }>('/users').then((r) => r.data),
  update: (id: string, patch: OrgUserPatch) =>
    api.patch<{ user: OrgUserRow }>(`/users/${id}`, patch).then((r) => r.data.user),
  resetPassword: (id: string) => api.post<void>(`/users/${id}/reset-password`).then(() => undefined),
  // Org-admin per-app role management for the caller's own org.
  appRoles: () => api.get<{ roles: AppRolesResponse }>('/users/app-roles').then((r) => r.data.roles),
  updateAppRoles: (userId: string, body: UpdateAppRolesBody) =>
    api
      .patch<{
        results: {
          wapsign?: AppRoleUpdateStatus;
          wapmeet?: AppRoleUpdateStatus;
          wapstat?: AppRoleUpdateStatus;
          wappro?: AppRoleUpdateStatus;
          wapdocs?: AppRoleUpdateStatus;
        };
      }>(
        `/users/${userId}/app-roles`,
        body,
      )
      .then((r) => r.data.results),
  provisionApp: (userId: string, body: ProvisionAppBody) =>
    api
      .post<{ result: AppProvisionStatus }>(`/users/${userId}/app-provision`, body)
      .then((r) => r.data.result),
};
